import '@babel/polyfill';
import Vue from 'vue';

import * as Sentry from '@sentry/vue';

import store from './store/index';
import router from './router/index';
import i18n from './translation/i18n';
import App from './App.vue';

import checkView from 'vue-check-view';

import Vuetify from 'vuetify';
import './stylus/main.styl';
import './assets/css/app.scss';

import pl from 'vuetify/src/locale/pl';
import VueTheMask from 'vue-the-mask';
import browserDetect from 'vue-browser-detect-plugin';
import VueGtm from 'vue-gtm';

import customColors from '@/constants/colors';
import interceptorSetup from './services/interceptor';
import validationSetUp from './services/validationConfig';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { version } from '../package.json';

const options = {
    position: 'top-right',
    timeout: 5000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: 'button',
    icon: true,
    rtl: false
};

Vue.config.devtools = process.env.VUE_APP_DEVTOOLS === 'true';

interceptorSetup();
validationSetUp();

Vue.use(Vuetify, {
    theme: customColors,
    lang: {
        locales: { pl },
        current: 'pl'
    },
    icons: {
        checkboxOn: 'check',
        checkboxOff: '',
        radioOn: '',
        radioOff: ''
    }
});

Vue.use(Toast, options);
Vue.use(checkView);
Vue.use(VueTheMask);
Vue.use(browserDetect);

Vue.use(VueGtm, {
    id: 'GTM-MP54W9Z'
});

if (process.env.VUE_APP_SENTRY_URL) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_URL,
        environment: process.env.VUE_APP_SENTRY_ENVIRONMENT,
        release: `szp2-frontend@${version}`,
        ignoreErrors: ['AxiosError']
    });
}

export default new Vue({
    i18n,
    store,
    router,
    el: '#app',
    render: (createElement) => createElement(App)
});
